export const FAQDtotoFAQ = (item) => ({
    faqCategorieId: item.FAQCategoriaId,
    id: item.Id,
    title: item.Titulo,
    desc: item.Descricao,
    htmlContent: item.Conteudo,
    index: item.Ordem,
});
export const FaqListDTOToFaqList = (FAQList) => FAQList?.map(dto => FAQDtotoFAQ(dto));
export const CategorieDtoToCategorie = (item) => ({
    FAQs: FaqListDTOToFaqList(item.FAQs),
    id: item.Id,
    title: item.Titulo,
    desc: item.Descricao,
    index: item.Ordem,
});
export const CategorieListDtoToCategorieList = (Categories) => Categories?.map(dto => CategorieDtoToCategorie(dto));
